module.exports = __webpack_public_path__ + "fa-solid-900.svg?5ff6f359bce5e321b4344791dd62874b";